import { Clock, WarningCircle, CheckCircle } from "@phosphor-icons/react";

const STYLE = {
  overdue: "bg-red-100 text-red-700 border-red-300",
  due_soon: "bg-amber-100 text-amber-800 border-amber-300",
  on_track: "bg-emerald-100 text-emerald-700 border-emerald-300",
};

export function SlaPill({ sla, className = "" }) {
  if (!sla || !sla.state) return null;
  const d = sla.days_left;
  const Icon = sla.state === "overdue" ? WarningCircle : sla.state === "due_soon" ? Clock : CheckCircle;
  const text = sla.state === "overdue" ? `Overdue ${Math.abs(d)}d`
    : sla.state === "due_soon" ? `Due in ${d}d`
    : `${d}d left`;
  return (
    <span data-testid={`sla-pill-${sla.state}`}
      className={`inline-flex items-center gap-1 rounded-none border px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${STYLE[sla.state] || ""} ${className}`}>
      <Icon size={11} weight="fill" /> {text}
    </span>
  );
}
